import jhsfBookingsApi from '../apis/jhsfBookingsApi';
import { ISpotModalityBase } from '../../models/spots';

interface ICreateSpotModalityProps {
  spotId: string;
  description?: string;
  isActive: boolean;
  isExclusive: boolean;
  title: string;
}

export type INewSpotModality = ISpotModalityBase;

export const createSpotModalitiesService = async ({
  spotId,
  description,
  isActive,
  isExclusive,
  title,
}: ICreateSpotModalityProps): Promise<INewSpotModality> => {
  const { data } = await jhsfBookingsApi.post<INewSpotModality>(
    `/spots/${spotId}/modalities`,
    {
      description,
      isActive,
      isExclusive,
      title,
    },
  );

  return data;
};
